<template>
    <el-dialog class="action-generate_permalink" title="Permalink" v-loading="loader" :visible.sync="display" top="2vh" width="70%">
        <div class="mb-3">Modifier les {{ items_selected }} produits selectionnés</div>
        <el-form class="formGeneratePermalink" ref="form" :model="form" >
            <p>Regénére les parmalinks</p>
        </el-form>
        <span slot="footer" class="dialog-footer">
            <el-switch v-model="sync" active-text="Synchroniser ?"></el-switch>
            <el-button @click="display = false">Annuler</el-button>
            <el-button type="primary" @click="action">Enregistrer</el-button>
        </span>
    </el-dialog>
</template>
<script>
export default {
    data() {
        return {
            display: false,
            loader: false,
            form: {},
            sync: false,
        };
    },
    props: {
        applyToAllResult: {
            default: false
        },
        filters: {
            default: null
        },
        selected: {
            default: []
        },
        total_item: {
            default: 0
        }
    },
    computed: {
        items_selected() {
            return this.applyToAllResult
                ? this.total_item
                : this.selected.length;
        }
    },
    methods: {
        open() {
            this.display = true;
            this.$store.dispatch('products/setLoader', false);
        },
        action() {
            var products = this.selected.map(v => v.id);
            this.loader = true;
            let form = {};
            var datas = {
                products,
                datas: form,
                mode: 'generate_permalink',
                sync: this.sync,
            };
            if (this.applyToAllResult) {
                datas.filters = this.filters;
            }
            datas.total_item = this.total_item
            datas.items_selected = this.items_selected
            axios
                .post('/products/bulk', datas)
                .then(r => {
                    this.$emit('saved', r);
                    this.$refs.form.resetFields();
                    this.display = false;
                })
                .catch(() => {})
                .then(() => {
                    this.loader = false;
                });
        }
    }
};
</script>
<style lang="scss">
    .action-change_seo {
        .mb-0 {
            margin-bottom: 0px;
        }
        .el-form-item {
            margin-bottom: 2px;
        }
    }
</style>
